/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceData } from './InvoiceData';
import {
    InvoiceDataFromJSON,
    InvoiceDataFromJSONTyped,
    InvoiceDataToJSON,
    InvoiceDataToJSONTyped,
} from './InvoiceData';

/**
 * 
 * @export
 * @interface InvoiceListData
 */
export interface InvoiceListData {
    /**
     * 
     * @type {Array<InvoiceData>}
     * @memberof InvoiceListData
     */
    data?: Array<InvoiceData>;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceListData
     */
    hasMore?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceListData
     */
    nextCursor?: string | null;
}

/**
 * Check if a given object implements the InvoiceListData interface.
 */
export function instanceOfInvoiceListData(value: object): value is InvoiceListData {
    return true;
}

export function InvoiceListDataFromJSON(json: any): InvoiceListData {
    return InvoiceListDataFromJSONTyped(json, false);
}

export function InvoiceListDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceListData {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(InvoiceDataFromJSON)),
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
        'nextCursor': json['nextCursor'] === undefined ? undefined : json['nextCursor'] === null ? null : json['nextCursor'],
    };
}

export function InvoiceListDataToJSON(json: any): InvoiceListData {
    return InvoiceListDataToJSONTyped(json, false);
}

export function InvoiceListDataToJSONTyped(value?: InvoiceListData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(InvoiceDataToJSON)),
        'hasMore': value['hasMore'],
        'nextCursor': value['nextCursor'],
    };
}

